//External Imports
import React, { memo, useContext } from 'react'

//Internal Imports
import Button from 'components/common/button'
import { LanguageContext } from 'context/LanguageContext'
import { LayoutContext } from 'context/LayoutContext'

const ResetSuccess = memo(props => {
    const { strings } = useContext(LanguageContext)

    const { closePanel, panelOpen } = useContext(LayoutContext)
    const closeReset = () => {
        if (panelOpen) {
            closePanel()
        } else {
            props.hide()
        }
    }
    return (
        <div className={'form resetPasswordSuccessForm'}>
            <div className={'form-header resetPasswordSuccessHeader'}>
                <p className={'form-header-title'}>{strings.resetPassword}</p>
                <p className={'form-header-sub'}>{strings.thankyouEmail}</p>
                <p className={'form-header-sub-sub'}>{strings.validAccount}</p>
            </div>
            <div className={'form-buttons'}>
                <Button className={'confirm confirm-lg'} onClick={closeReset}>
                    {strings.okButton}
                </Button>
            </div>
        </div>
    )
})

export default ResetSuccess
